import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      width: 54,
      height: 54,
      margin: [-7, 0, 0, -7],
    },
  },
  {
    name: 'Lock',
  },
);
